<template>
	<div class="bg">
		<im-nav></im-nav>
		<el-tabs :tab-position="tabPosition">
			<el-tab-pane label="我的应用">
				<div class="box">
					<div class="mynav">
						<div class="navtxt">我的应用</div>


					</div>
					<div class="tabble">
						<el-table :data="applist" border style="width: 100%">
							<el-table-column fixed prop="uid" label="id" width='80'>
							</el-table-column>
							<el-table-column prop="appname" label="应用名" width='150'>
							</el-table-column>
							<el-table-column prop="appid" label="appid">
							</el-table-column>
							<el-table-column prop="callbackurl" label="回调地址" width='300'>
								<template slot-scope="scope">
									<div>{{scope.row.callbackurl}}</div>
									<el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
								</template>
							</el-table-column>
							<el-table-column prop="status" label="应用状态">
								<template slot-scope="scope">
									<el-select size='small' @change='changestatus($event,scope.row.appid)' v-model="value[scope.row.appid]"
									 :placeholder="scope.row.status==0?'已禁用':scope.row.status==1?'已启用':'已启用并禁用回调'">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
									<!-- <div>{{scope.row.status==0?'禁用':scope.row.status==1?'启用':'启用并禁用回调'}}</div>
									<el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
								</template>
							</el-table-column>
							<el-table-column prop="createtime" label="创建时间">
							</el-table-column>
							<el-table-column fixed="right" label="apptoken" width="150">
								<template slot-scope="scope">
									<!-- <div>{{apptoken}}</div> -->
									<el-button @click="look(scope.row.appid)" type="text" size="small">查看</el-button>
									<el-button @click="reset(scope.row.appid)" type="text" size="small">重新获取</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="新建应用">
				<div class="box">
					<div class="mynav">
						<div class="navtxt">新建应用</div>
						<el-form ref="form" :model="form" label-width="80px">
							<el-form-item label="应用名称">
								<el-input v-model="form.name"></el-input>
							</el-form-item>
							<el-form-item label="应用状态">
								<el-radio-group v-model="form.status">
									<el-radio :label="0">禁用</el-radio>
									<el-radio :label="1">启用</el-radio>
									<el-radio :label="2">启用并禁用回调</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" @click="onSubmit()">立即创建</el-button>
								<!-- <el-button>取消</el-button> -->
							</el-form-item>
						</el-form>

					</div>
					<div class="tabble">

					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-dialog title="设置回调地址" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
			<div class="form">
				<div class="item">
					<div class="txt">新地址</div>
					<div class="input-box">
						<input v-model="callbackurl" type="text" />
					</div>
				</div>
				<!-- <div class="item">
					<div class="txt">appid</div>
					<div class="input-box">
						<input v-model="appid" type="text" />
					</div>
				</div> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="setcallback()">确 定</el-button>
			</span>
		</el-dialog>
		<mybottom></mybottom>
	</div>
</template>
<script>
	import imNav from "../components/nav.vue"
	import mybottom from "../components/mybottom.vue"
	export default {
		components: {
			imNav,
			mybottom
		},
		data() {
			return {
				tabPosition: 'left',
				dialogVisible: false,
				applist: [{
						"uid": 4,
						"appname": "御风猫活动",
						"appid": "34465cd454",
						"callbackurl": "https://v3.yfcat.com/index/message/dealMsgCallback",
						"status": 1,
						"createtime": "2020-12-05 16:17:31"
					},
					{
						"uid": 2,
						"appname": "御风猫活动",
						"appid": "34465cd452",
						"callbackurl": "https://v3.yfcat.com/index/message/dealMsgCallback",
						"status": 1,
						"createtime": "2020-12-05 16:17:31"
					},
				],
				options: [{
						label: '禁用',
						value: 0
					},
					{
						label: '启用',
						value: 1
					},
					{
						label: '启用并禁用回调',
						value: 2
					}
				],
				callbackurl: '',
				status: '',
				appid: '34465cd454',
				apptoken: '34465cd454',
				value: {},
				form: {
					name: '',
					status: 0
				}
			};
		},
		created() {
			this.getapplist()
		},
		methods: {
			reset(appid) {
				this.$confirm('重新获取后，之前的apptoken将失效，确认重新获取吗？')
					.then(_ => {

						this.$http.post('index/resetAppToken', {
							appid:appid
						}).then(res => {
							console.log(res)
							if (res.status == 200) {
								// this.value = e==0?'禁用':e==1?'启用':'启用并禁用回调'
								this.$message('获取成功');
							} else {
								this.$message('获取失败');
							}
						})
					})
					.catch(_ => {});
			},
			onSubmit() {
				console.log(this.form)
				this.$http.post('index/createAppByUid', {
					appname: this.form.name,
					status: this.form.status
				}).then(res => {
					console.log(res)
					if (res.status == 200) {
						// this.value = e==0?'禁用':e==1?'启用':'启用并禁用回调'
						this.$router.go(0)
						this.$message('创建成功');
					} else {
						this.$message('创建失败');
					}
				})

			},
			setcallback() {
				console.log(this.appid, this.callbackurl)
				this.$http.post('index/setAppCallbackUrl', {
					callbackurl: this.callbackurl,
					appid: this.appid
				}).then(res => {
					console.log(res)
					if (res.status == 200) {
						// this.value = e==0?'禁用':e==1?'启用':'启用并禁用回调'
						this.applist.forEach(item => {
							if (item.appid == this.appid) {
								item.callbackurl = this.callbackurl
							}
						})
						this.$message('设置成功');
						this.dialogVisible = false
					} else {
						this.$message('设置失败');
						this.dialogVisible = false
					}
				})
			},
			changestatus(e, appid) {
				console.log(e, appid)
				this.appid = appid
				this.$http.post('index/setAppStatus', {
					status: e,
					appid: this.appid
				}).then(res => {
					console.log(res)
					if (res.status == 200) {
						this.value[appid] = e == 0 ? '禁用' : e == 1 ? '启用' : '启用并禁用回调'
						this.$message('设置成功');
					} else {
						this.$message('设置失败');
					}
				})
			},
			look(appid) {
				this.appid = appid
				this.$http.post('index/getAppTokenByAppId', {
					appid: this.appid
				}).then(res => {
					console.log(res)
					if (res.status == 200) {
						this.apptoken = res.apptoken
						this.$alert(this.apptoken, 'apptoken', {
							confirmButtonText: '确定',
							callback: action => {

							}
						});
					} else {
						this.apptoken = '获取失败'
						this.$alert(this.apptoken, 'apptoken', {
							confirmButtonText: '确定',
							callback: action => {

							}
						});
					}
				})




			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			handleClick(row) {
				this.dialogVisible = true
				this.callbackurl = row.callbackurl
				this.appid = row.appid
				console.log(row);
			},
			getapplist() {
				this.$http.post('index/getAppListByUid', {

				}).then(res => {
					console.log(res)
					if (res.status == 200) {

					} else {
						this.$message('登陆信息已过期，请重新登陆');
						// this.$router.go(-1)
						// localStorage.removeItem('name')
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	};
</script>
<style scoped="scoped">
	.bg{
		width: 100vw;
		height: 100vh;
		background-color: white;
		position: relative;
	}
	input {
		border: 0px;
		outline: none;
		width: 100%;
	}

	.form {
		width: 100%;
		height: 40%;
		background-color: white;
		border-radius: 5px;
	}

	.txt {
		font-size: 15px;
	}

	.txt1 {
		width: 100px;
		height: 100px;
	}

	.item {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin: 20px;
	}

	.item1 {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}

	.input-box {
		width: 60%;
		border-bottom: 1px solid #222200;
	}

	.form {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.box {
		width: 90%;

	}



	.navtxt {
		margin-left: 20px;
		margin-bottom: 20px;
	}

	.mynav {
		padding: 30px;
		font-size: 25px;

		font-weight: 600;
	}
</style>
